import * as React from 'react';
import buildContentfulAssetUrl from 'ha/utils/buildContentfulAssetUrl';
import buildContentfulAssetSrcSet from 'ha/utils/buildContentfulAssetSrcSet';
import Img, { Props as ImgProps } from 'ha/ui/next/Img';

interface Props {
  src: string;
  isMobile: boolean;
  format?: 'jpg' | 'png';
  quality?: number;
  assetWidth?: number;
  assetHeight?: number;
}

const ContentfulImg: React.SFC<ImgProps & Props> = ({
  src,
  assetWidth,
  assetHeight,
  isMobile,
  quality,
  format,
  ...rest
}) => (
  <Img
    role="presentation"
    {...rest}
    src={buildContentfulAssetUrl(src, {
      width: assetWidth,
      height: assetHeight,
      format,
      quality,
    })}
    srcSet={
      !isMobile
        ? buildContentfulAssetSrcSet(src, {
            width: assetWidth,
            height: assetHeight,
            format,
            quality,
          })
        : null
    }
  />
);

ContentfulImg.defaultProps = {
  format: 'jpg',
  quality: 70,
};

export default ContentfulImg;
